import { render, staticRenderFns } from "./SidebarListGroupItem.vue?vue&type=template&id=11cb1a78&scoped=true&"
import script from "./SidebarListGroupItem.vue?vue&type=script&lang=js&"
export * from "./SidebarListGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarListGroupItem.vue?vue&type=style&index=0&id=11cb1a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cb1a78",
  null
  
)

export default component.exports